import { appkeyByappIdHandle, appIdIconMap, changeFavicon } from "@/utils/auth";
export default {
  name: "App",
  watch: {
    "$route.query.appkey": {
      handler() {
        this.updateTitleAndIcon();
      },
      immediate: true
    }
  },
  mounted() {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "viewport");
    meta.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
    document.getElementsByTagName("head")[0].appendChild(meta);
  },
  methods: {
    updateTitleAndIcon() {
      let {
        appkey
      } = this.$route.query;
      const appId = appkeyByappIdHandle(appkey);
      const appInfo = appIdIconMap[appId];
      if (!appInfo) return;
      // 每个app的隐私协议有多个标题，此处注释掉-不用对应App的名称，改成渲染public下的每个独立静态页面里的title
      // document.title = appInfo.name;
      changeFavicon(appInfo.icon);
    }
  }
};